<template></template>
<script>
export default {
  mounted() {
    if(confirm(this.$t('repair.text.repairdelete') + ' OS' + ("00000000" + this.$route.params.id).slice(-8) + '?')){
      this.$store
        .dispatch("repairs/delete", this.$route.params.id)
        .then(resp => {
          this.$router.push({ name: "repairs" });
          this.$notify({
            type: "success",
            message: this.$t('repair.message.successdelete')
          });
        })
        .catch(error => {
          this.$notify({
            type: "danger",
            message: this.$t('repair.message.errordelete')
          });
        });
    } else {
      this.$router.push({ name: "repairs" });
    }
  }
};
</script>
<style>
</style>
